// Copyright © Veeam Software Group GmbH
/* eslint-disable */
// Autogenerated

export enum LocationType {
    StandaloneProxy = 0,
    ProxyPool = 1
}
